import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  plans: localStorage.getItem('plans') && JSON.parse(localStorage.getItem('plans'))  || []
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/plans/index.js